import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Badge } from '@/components/ui/badge'
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemTitle,
} from '@/components/ui/item'
import type { LinkedHazardSummary } from './buildEhsrOverviewModel'

type LinkedHazardsListProps = {
  hazards: LinkedHazardSummary[]
}

export function LinkedHazardsList({ hazards }: LinkedHazardsListProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  if (hazards.length === 0) {
    return null
  }

  return (
    <ul className='space-y-1'>
      {hazards.map((hazard) => {
        const typeLabel =
          hazard.type != null
            ? t(`hazardsPage.enums.hazardTypes.${hazard.type}`)
            : t('hazardsPage.hazardDetail.na')
        const title = `${typeLabel} — ${hazard.id}`

        return (
          <li key={hazard.id}>
            <Item
              variant='outline'
              size='sm'
              className='hover:bg-accent hover:text-accent-foreground'
              render={<Link relative='route' to={`../hazards/${hazard.id}`} />}
            >
              <ItemContent>
                <ItemTitle className='flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1'>
                  <span className='inline-flex min-w-0 items-center gap-1.5'>
                    <span className='truncate'>{title}</span>
                    <Badge
                      variant='outline'
                      className='border-amber-300 bg-amber-50 font-normal text-amber-800'
                    >
                      {t('ehsrsOverviewPage.badgeHazards')}
                    </Badge>
                  </span>
                </ItemTitle>
                {hazard.description != null &&
                  hazard.description.trim().length > 0 && (
                    <ItemDescription className='line-clamp-2 text-xs text-muted-foreground'>
                      {hazard.description}
                    </ItemDescription>
                  )}
              </ItemContent>
              <ItemActions>
                <span className='text-sm font-medium text-muted-foreground'>
                  {t('ehsrsOverviewPage.view')}
                </span>
              </ItemActions>
            </Item>
          </li>
        )
      })}
    </ul>
  )
}
